module.exports = __webpack_public_path__ + "static/img/63.d018072.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/20/63.jpg
// module id = 727
// module chunks = 0